import { render, staticRenderFns } from "./RightSidebarContent.vue?vue&type=template&id=59f3c202&scoped=true"
import script from "./RightSidebarContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RightSidebarContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RightSidebarContent.vue?vue&type=style&index=0&id=59f3c202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f3c202",
  null
  
)

export default component.exports